import * as React from 'react';

import cx from 'classnames';

import { FocusIndicator } from '../FocusIndicator/FocusIndicator';

interface Props {
  children: NonNullable<React.ReactNode>;
  className?: string;
  disabled?: boolean;
  value?: string;
  label: string;
}

export const QuillToolbarButton = ({
  children,
  label,
  className = '',
  ...props
}: Props) => {
  const buttonRef = React.useRef<HTMLButtonElement>();
  const buttonClasses = buttonRef.current?.classList;
  const [isActive, setIsActive] = React.useState(false);

  React.useEffect(() => {
    setIsActive(buttonClasses?.contains('ql-active'));
  }, [buttonClasses]);

  const buttonClass = React.useMemo(
    () =>
      cx(
        'relative flex-none h-8 min-w-8 p-1 m-0',
        'text-grey-700 border-0 bg-transparent rounded-1',
        'cursor-pointer outline-none transition-colors duration-100 ease-linear',
        'toolbar-button',
        {
          [className as string]: !!className,
        }
      ),
    [className]
  );

  return (
    <button
      ref={buttonRef}
      type="button"
      aria-label={label}
      className={buttonClass}
      {...props}
    >
      <FocusIndicator
        notOffset
        isInset={!isActive}
        includesWhiteInset={isActive}
      />
      <div className="flex items-center justify-center">{children}</div>
    </button>
  );
};
